import { database } from '@/firebase';

const {
  updateRecord,
  getRecord,
  getCollection,
} = database;

const fetch = (payload) => {
  const { id } = payload;
  if (id) {
    return getRecord(payload);
  }
  return getCollection(payload);
};

export default {
  fetch({ commit }, payload) {
    return fetch(payload).then((response) => {
      if (response) {
        commit('set', { value: response, ...payload });
      }
    });
  },
  update(state, { model, id, value }) {
    return updateRecord({ model, id, value });
  },
  set({ commit }, { model, value }) {
    commit('set', { model, value });
  },
  fetchSite({ commit }) {
    return fetch({
      model: 'site',
      group: true,
    }).then((response) => {
      if (response) {
        commit('set', { model: 'site', value: response });
      }
      return true;
    });
  },
};
